const emailValidation = (value) => {

  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(value);

};

const phoneValidation = (value) => {

  // let re = /^\({0,1}((0|\+61|61){1}[0-9]){1}\){0,1}(\ |-){0,1}[0-9]{8}$/;
  let re = /^\({0,1}((0|\+61|61){1}[4]){1}\){0,1}(\ |-){0,1}[0-9]{8}$/;

  return re.test(value);

};

const removeURLParameter = (url, parameter) => {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {

    var prefix = encodeURIComponent(parameter) + '=';
    var pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (var i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    url = urlparts[0] + '?' + pars.join('&');
    return url;
  } else {
    return url;
  }
}

const getPhoneForValidation = (phone) => {
  
  if (phone.lastIndexOf("+61", 0) === 0) {
    return phone;
  }

  if (phone.lastIndexOf("61", 0) === 0) {
    return "+" + phone;
  }

  return "+61" + phone.slice(1);
};

const getCurrentDateTime = () => {
  const date = new Date();
  const dateStr =
    date.getFullYear() +
    "-" +
    ("00" + (date.getMonth() + 1)).slice(-2) +
    "-" +
    ("00" + date.getDate()).slice(-2) +
    " " +
    ("00" + date.getHours()).slice(-2) +
    ":" +
    ("00" + date.getMinutes()).slice(-2) +
    ":" +
    ("00" + date.getSeconds()).slice(-2);

  return dateStr;
};

export default {
  emailValidation,
  phoneValidation,
  getPhoneForValidation,
  removeURLParameter,
  getCurrentDateTime
};
